<template>
    <div>
        <step1 v-if="st1" @sendPartner="setPartner($event,2)"></step1>
        <step2 v-if="st2" @sendPartner="setPartner($event,3)" :partner="partner"></step2>
        <step3 v-if="st3" @sendPartner="setPartner($event,4)" :partner="partner"></step3>
        <step4 v-if="st4" @sendPartner="setPartner($event,5)" :partner="partner"></step4>
    </div>
</template>

<script>
    import step1 from './Step1'
    import step2 from './Step2'
    import step3 from './Step3'
    import step4 from './Step4'

    export default {
        name: 'addPartners',
        components: {
            step1,
            step2,
            step3,
            step4,
        },
        data: function () {
            return {
                topmenu: [
                    {
                        name: 'Volver',
                        path: '/partners/accounts/list',
                        brand: 'fa fa-arrow-left'
                    },
                ],
                partner: null,
                st1: true,
                st2: false,
                st3: false,
                st4: false,
            }
        },
        mounted() {
            this.$eventHub.$emit('captureMenu', this.topmenu);
        },
        methods: {
            setPartner(partner, step) {
                this.partner = partner;
                switch (step) {
                    case 2:
                        this.st1 = false;
                        this.st2 = true;
                        this.st3 = false;
                        this.st4 = false;
                        break;
                    case 3:
                        this.st1 = false;
                        this.st2 = false;
                        this.st3 = true;
                        this.st4 = false;
                        break;
                    case 4:
                        this.st1 = false;
                        this.st2 = false;
                        this.st3 = false;
                        this.st4 = true;
                        break;
                    case 5:
                        this.partner = null;
                        this.st1 = true;
                        this.st2 = false;
                        this.st3 = false;
                        this.st4 = false;
                        break;
                    default:
                        this.partner = null;
                        this.st1 = true;
                        this.st2 = false;
                        this.st3 = false;
                        this.st4 = false;
                }
            }
        }
    }
</script>